import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";

// 网络配置
export const Network =
	import.meta.env.VITE_APP_ENV === "production" ? WalletAdapterNetwork.Mainnet : WalletAdapterNetwork.Devnet;

// RPC 端点配置
export const RPC_ENDPOINTS = {
	// 使用更可靠的 RPC 端点，避免 403 错误
	mainnet: "https://api.mainnet-beta.solana.com",
	// 备用 RPC 端点（更稳定）
	mainnetBackup: "https://solana-mainnet.g.alchemy.com/v2/demo", // Alchemy 的免费端点
	devnet: "https://api.devnet.solana.com",
};

// 获取当前应该使用的 RPC 端点
export const getCurrentRpcEndpoint = () => {
	if (Network === WalletAdapterNetwork.Mainnet) {
		// 优先使用环境变量，否则使用 Alchemy 的公共端点
		return import.meta.env.VITE_SOLANA_RPC_URL || RPC_ENDPOINTS.mainnetBackup;
	}
	return RPC_ENDPOINTS.devnet;
};

export default {
	Network,
	RPC_ENDPOINTS,
	getCurrentRpcEndpoint,
};
